mutation SetUserNotificationSettings($notificationSettings: InputUserNotificationSettings!) {
    setUserNotificationSettings(notificationSettings: $notificationSettings) {
        annotationSettings {
            mentions
            all
        }
        statusChangesSettings {
            approved
            inReview
            rejected
        }
        newUserJoins
        notificationFrequency {
            everytime
            daily
        }
    }
}
